import { useRouter } from "next/router";
import InspirationsItem from "./InspirationsItem";
import { Masonry } from "@mui/lab";

interface InspirationsItems {
  items: any;
  isMobile: boolean | undefined;
}

const InspirationsItems = ({ items, isMobile }: InspirationsItems) => {
  const { query } = useRouter();
  const isFeedback = query.feedback || false;
  const otc =
    typeof query.otc === "string" ? query.otc?.replace(" ", "") || "" : "";
  return (
    <>
      <div className="inspire__main--container">
        <Masonry columns={!isMobile ? 4 : 2} spacing={2}>
          {items.map((item: any, i: number) => (
            <InspirationsItem
              key={i}
              item={item}
              isFeedback={
                isFeedback && otc === item.feedbackCode && !item.feedbackGiven
              }
            />
          ))}
        </Masonry>
      </div>
    </>
  );
};

export default InspirationsItems;
